import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modalDetailLoanComponent from './modalDetailLoan.component';
import MyLoansService from '../../myLoans.service';

let modalDetailLoanModule = angular.module('modalDetailLoan', [
  uiRouter
])

.service('myLoansService', MyLoansService)

.component('modalDetailLoan', modalDetailLoanComponent)

.name;

export default modalDetailLoanModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailLoan/modalDetailLoan.js